import { parseDateLiteral } from '@/utils/chartAxisUtils';

export interface DateLabelWindowInfo {
  hasDateInfo: boolean;
  isDailyLike: boolean;
  windowDays: number | null;
}

export function getDateLabelWindowInfo(labels: string[]): DateLabelWindowInfo {
  const dates = labels
    .map((label) => parseDateLiteral(label))
    .filter((date) => !isNaN(date.getTime()));

  if (dates.length < 2) {
    return { hasDateInfo: false, isDailyLike: false, windowDays: null };
  }

  const diffsDays: number[] = [];
  for (let i = 1; i < dates.length; i += 1) {
    const diff = Math.abs(dates[i].getTime() - dates[i - 1].getTime()) / (1000 * 60 * 60 * 24);
    if (diff > 0) diffsDays.push(diff);
  }

  const sortedDiffs = diffsDays.sort((a, b) => a - b);
  const medianDiff = sortedDiffs.length
    ? sortedDiffs[Math.floor(sortedDiffs.length / 2)]
    : null;

  const windowDays = Math.abs(dates[dates.length - 1].getTime() - dates[0].getTime()) / (1000 * 60 * 60 * 24);

  return {
    hasDateInfo: true,
    isDailyLike: medianDiff !== null && medianDiff <= 2,
    windowDays,
  };
}

interface ShouldShowDataLabelsArgs {
  enabled: boolean;
  labels: string[];
  alwaysShow?: boolean;
  maxDailyWindowDays?: number;
}

export function shouldShowDataLabelsByFrequency({
  enabled,
  labels,
  alwaysShow = false,
  maxDailyWindowDays = 365,
}: ShouldShowDataLabelsArgs): boolean {
  if (!enabled) return false;
  if (alwaysShow) return true;

  const info = getDateLabelWindowInfo(labels);
  if (!info.hasDateInfo) return true;
  if (!info.isDailyLike) return true;
  if (info.windowDays === null) return true;

  return info.windowDays <= maxDailyWindowDays;
}
